function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.113281 9.53906C0.113281 9.83203 0.242188 10.1016 0.476562 10.3242L8.25781 18.0938C8.49219 18.3164 8.73828 18.4219 9.01953 18.4219C9.59375 18.4219 10.0508 18 10.0508 17.4141C10.0508 17.1328 9.94531 16.8516 9.75781 16.6758L7.13281 14.0039L3.18359 10.4062L6.01953 10.582H20.8438C21.4531 10.582 21.875 10.1484 21.875 9.53906C21.875 8.92969 21.4531 8.49609 20.8438 8.49609H6.01953L3.19531 8.67188L7.13281 5.07422L9.75781 2.40234C9.94531 2.21484 10.0508 1.94531 10.0508 1.66406C10.0508 1.07812 9.59375 0.65625 9.01953 0.65625C8.73828 0.65625 8.49219 0.75 8.23438 1.00781L0.476562 8.75391C0.242188 8.97656 0.113281 9.24609 0.113281 9.53906Z",
  fill: "#6D28D9"
});

function SvgBackPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackPurple);
export default __webpack_public_path__ + "static/media/back-purple.961fc057.svg";
export { ForwardRef as ReactComponent };